import React from 'react';

const BlogPage = () => {
    return (
        <div>
            <h1>Blog</h1>
            <p>Blog content here.</p>
        </div>
    );
};

export default BlogPage;